import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import axios from "axios";
import { API_BASE_URL } from "@/config/serverApiConfig";
import { Breadcrumb, Spinner } from "react-bootstrap";
import SubmitPopup from "@/components/UserView/Submitpopup/Submitpopup";




export default function ResetPassword() {
    const history = useHistory();
    const [email, setEmail] = useState("");
    const [emailIsEmptyErr, setEmailIsEmptyErr] = useState(false);

    let [updatedMSG, setUpdatedMSG] = useState(false);

    const [submitLoader, setSubmitLoader] = useState(false);
    const [msg, setMsg] = useState("");



    function closeupdateModal() {
        setUpdatedMSG(false);
      }

    // email handler
    function emailHandler(e) {
        let item = e.target.value;
        if(item.length < 1) {
            setEmailIsEmptyErr(true);
        } else {
            setEmailIsEmptyErr(false);
        }
        setEmail(item);
    }

    function submitHandler(e) {
        e.preventDefault();
        if(email.length < 1 || email === "") {
            setEmailIsEmptyErr(true);
        }
        else{
        setSubmitLoader(true);
        axios.post(`${API_BASE_URL}reset`, {
            email: email
        }).then(res => {
            setSubmitLoader(false);
            setMsg(res.data.message);
            setUpdatedMSG(true);
            
        }).catch(err => {
            setSubmitLoader(false);
            
        })
    }
    }
function redirect(){
    history.push("/admin/login");
}

    
    return (
        <>
        <SubmitPopup
       onClose={closeupdateModal}
       show={updatedMSG}
       title={msg}
     />
        <div className="container">
            <div className="row">
                 <div className="col-md-6 offset-md-3">
                     <div style={{"text-align": "center",
    "margin-top": "40px"}} className="logo">

                  <img src="./assets/images/logo_black.png" alt="logo" className="logocenter" />
                  </div>
                    <h1 style={{margin: "60px"}} className="text-center">Reset Password for Admin</h1>
                   
                    <form onSubmit={submitHandler}>
                
                        <div style={{"marginBottom": "20px", }} className="form-group">
                            <label htmlFor="confirmPassword">Enter your email</label>
                            <input 
                            style={{paddingLeft: "8px", border: "none"}}
                                type="text"
                                name="email"
                                className="form-control"
                                id="email"
                                placeholder="john@mail.com"
                                onChange={emailHandler}
                               
                            />
                            {emailIsEmptyErr ? (
                               <span className="error-msg">Please enter a valid email address</span>
                             ) : (
                               ""
                             )}
                        </div>
                        <div style={{ margin:"10 0", textAlign:"center" }}>
                    <button style={{"border-radius": "6px",
    padding: "15px 20px",
    width: "200px", marginRight: "10px"}} type="submit" onSubmit={submitHandler} className="btn-full-color"> <Spinner
                      as="span"
                      animation={submitLoader ? 'border' : ''}
                      size="large"
                      role="status"
                      aria-hidden="false"
                    />Reset Password</button>
                    <button style={{borderRadius: "6px",
    padding: "15px 20px",
    width: "200px", marginLeft: "10px"}}  onClick={redirect} className="btn-full-color"> Login Page</button>
                    </div>
                  
                  </form>
                 
                </div> 
            </div> 
        </div>
        </>
    );
}